// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"AuditUploads_overlayWrapper__bBg5k","searchBox":"AuditUploads_searchBox__UTt3V","tablestyle":"AuditUploads_tablestyle__22yO+"};